import { render, staticRenderFns } from "./EquipIdentify.vue?vue&type=template&id=b1fb2fc4&scoped=true"
import script from "./EquipIdentify.vue?vue&type=script&lang=js"
export * from "./EquipIdentify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1fb2fc4",
  null
  
)

export default component.exports